import { render, staticRenderFns } from "./InternshipSponsorPostulations.vue?vue&type=template&id=94ba750c&"
import script from "./InternshipSponsorPostulations.vue?vue&type=script&lang=js&"
export * from "./InternshipSponsorPostulations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports